/* unplugin-vue-components disabled */import script from "./GoogleAuth.vue?vue&type=script&lang=ts&setup=true"
export * from "./GoogleAuth.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__